<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="120px"
          >
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="10">
                <el-form-item :label="$t('desc.insightType')">
                  <el-select
                    v-model="formselect.insightCode"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                    @change="changeInsight"
                  >
                    <el-option
                      v-for="item in insightCodeArr"
                      :value="item.insightCode"
                      :label="item.insightCode+' '+(activeLang == 'zh'?item.insightName:item.insightEn)"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="isShowInsightType" :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('desc.insightType')">
                  <el-select
                    v-model="formselect.SelectCode"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :value="item.value"
                      :label="item.label"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="6" style="margin-top: 10px">
                <el-button
                  type="primary"
                  @click="getInsightList('search')"
                  size="small"
                  >{{ $t("button.query") }}</el-button
                >
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div v-show="isShowCHart" class="KPIBlockDiv">
            <div class="block">
              <h4>{{chartTitle}}</h4>
              <div
                class="echarts npPointer"
                style="height: 260px"
                id="CountBar"
              ></div>
            </div>
          </div>
          <template>
            <div class="tableDiv">
              <el-table
                v-loading="tableLoading"
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="insightId"
                  :label="'Insight ID'"
                  width="140"
                >
                </el-table-column>

                <el-table-column
                  prop="calculateTime"
                  :label="$t('desc.screeningTime')"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="gsn"
                  :label="$t('desc.gatewaySN')"
                  width="140"
                >
                </el-table-column>

                <el-table-column
                  prop="dsn"
                  :label="$t('desc.airCompressorSN')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="modelName"
                  :label="$t('title.airCompressorType')"
                  width="160"
                >
                </el-table-column>

                <el-table-column
                  prop="customerName"
                  :label="$t('desc.customerName')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="customerCenter"
                  :label="$t('title.customerCenter')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="manageCpName"
                  :label="$t('title.managementUnit')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="serviceType"
                  :label="$t('title.airCompressorService')"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  v-for="item in columnArr"
                  :prop="item.prop"
                  :label="$t('insight.'+ item.name)"
                  :width="item.width"
                  :key="item.name"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.operate')"
                  width="80"
                  fixed="right"
                  v-if="isShowDownload"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-download"
                      :title="$t('button.details')"
                      circle
                      size="mini"
                      v-show="hasDownLoadAuth"
                      @click="downLoadRunTImeFileFromS3(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import {
  getInsightList,
  getInsightStatList,
  authOperationCheck,
  getInsightChart,
  downLoadInsightFileFromS3
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "index",
  components: {},
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  data() {
    return {
      tableLoading: false,
      insightCodeArr: [],
      formselect: {},
      tableData1: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      columnArr: [],
      isShowInsightType: false,
      typeOptions: [],
      chartDataArr: [],
      isShowCHart: false,
      chartTitle:"",
      hasDownLoadAuth:false,
      isShowDownload:false,
      echartID:{}
    };
  },
  created: function () {
    this.authOperation("DeviceAnalysis");

    // var _self = this;
    // this.$nextTick(() => {
    //   _self.initCountBar();
    // });
  },
  async mounted() {
    await this.getInsightStatList();
    await this.getInsightList();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasDownLoadAuth = res.hasDownLoadAuth;
    },
    async getInsightStatList() {
      let that = this;
      let res = await getInsightStatList();
      that.insightCodeArr = res.result;
      that.$set(
        that.formselect,
        "insightCode",
        that.insightCodeArr[0]?.insightCode
      );
    },
    async getInsightList(type = "normal") {
      let that = this;
      that.tableLoading = true;
      let chartType = ["2.1","2.7","2.9"];
      if (chartType.some(x=>x === that.formselect.insightCode)) {
        that.isShowCHart=true;
        that.echartID = this.$echarts.init(document.getElementById("CountBar"));
        that.echartID.showLoading({
          text: "loading",
          color: "#3A6BB5",
          textColor: "#000",
          maskColor: "#242731",
        });
      }else{
        that.isShowCHart=false;
      }
      await that.getColumn();
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        InsightCode: that.formselect.insightCode,
        SelectCode: that.formselect.SelectCode,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      try {
        let res = await getInsightList(postData);
        
        if(that.formselect.insightCode === "2.1") {
          that.chartTitle = that.$t("insight.insightTitle21")
        }else if(that.formselect.insightCode  === "2.7"){
          that.chartTitle = that.$t("insight.insightTitle27")
        }else if(that.formselect.insightCode === "2.9"){
          that.chartTitle = that.$t("insight.insightTitle29")
        }
        if (chartType.some(x=>x === that.formselect.insightCode)) {
          await that.getInsightChart();
        }
        that.tableLoading = false;
        let data = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
        data.forEach((element) => {
          if (that.formselect.insightCode === "1.2") {
            if (that.formselect.SelectCode === "Hose") {
              element.oilReplaceTime = 16000;
            }else{
              element.oilReplaceTime = 40000;
            }
          }
          element.calculateTime = element.calculateTime.split("T")[0];
          if (element.utilization || element.utilization == 0) {
            element.utilization =((element.utilization * 100).toFixed(2))+"%"
          }
        });
        that.tableData1 = data;
      } catch (error) {
        that.tableLoading = false;
        that.echartID.hideLoading();
      }
    },
    async getInsightChart(){
      let that = this;
      that.chartDataArr=new Array();
      let postData = {
        InsightCode: that.formselect.insightCode,
        SelectCode: that.formselect.SelectCode,
      };
      let res = await getInsightChart(postData);
      that.chartDataArr = res.result;
      that.$nextTick(()=>{
        that.echartID.resize();
        that.initCountBar();
        
      })
    },
    async getColumn(){
      let that = this;
      let type1 = ["1.1","1.2"];
      //来源2：1.4 1.5 1.3 2.2 2.3 2.4 2.5 2.7
      //来源1：
      let type2 = ["1.3","1.4","1.5","2.2","2.3","2.4","2.5"];

      let type3 = ["1.3","1.4","1.5","1.6","2.2","2.3","2.4","2.5","2.6"];
      if (type3.some(x=>x === that.formselect.insightCode)) {
        that.isShowDownload=true;
      }else{
        that.isShowDownload=false;
      }
      
      let columnArr= new Array();
      if (type1.some(x=>x === that.formselect.insightCode)) {
        let replaceDate = "";
        if (that.formselect.SelectCode === "Oil"){
          replaceDate = "oilReplaceTime";
        }else if (that.formselect.SelectCode === "inleTvacuum") {
          replaceDate = "airReplaceTime";
        }else if (that.formselect.SelectCode === "Separator_Element") {
          replaceDate = "separatorReplaceTime";
        }else{
          replaceDate = "oilReplaceTime";
        }
        columnArr = [
          { name: "已运行时长", prop: "runningTime", width: 120 },
          { name: "上次更换日", prop: "beforTime", width: 120 },
          { name: "上次更换运行时长", prop: "beforRunningTime", width: 130 },
          { name: "推荐更换周期", prop: replaceDate, width: 120 },
        ];
      }else if (type2.some(x=>x === that.formselect.insightCode)){
        columnArr = [
          { name: "首次预报警时间", prop: "alarmBegin", width: 180 },
          { name: "末次预报警时间", prop: "alarmEnd", width: 180 },
          { name: "来源-2", prop: "from2", width: 200 },//prop待定
        ];
      }else if (that.formselect.insightCode === "1.6") {
        columnArr = [
          { name: "前两周低气压状态占比", prop: "firstPercent", width: 120 },
          { name: "后两周低气压状态占比", prop: "secendPercent", width: 120 },
        ];
      }else if (that.formselect.insightCode === "1.7"){
        columnArr = [
          { name: "日（告警时间）", prop: "runningHour", width: 120 },//prop待定
          { name: "告警信息", prop: "airReplaceTime", width: 120 },//prop待定
          { name: "原因", prop: "beforRunningTime", width: 130 },//prop待定
          { name: "解决方案", prop: "replaceTime", width: 120 },//prop待定
        ];
      }else if (that.formselect.insightCode === "2.1"){
        columnArr = [
          { name: "频繁开关机", prop: "point12", width: 120 },
          { name: "机组排期压力", prop: "point21", width: 120 },
          { name: "长时间卸载", prop: "point22", width: 130 },
          { name: "频繁加卸载", prop: "point23", width: 120 },
          { name: "油分", prop: "point243", width: 120 },
          { name: "油滤", prop: "point244", width: 120 },
          { name: "空滤", prop: "point245", width: 120 },
          { name: "冷却风进气温度", prop: "point31", width: 120 },
          { name: "总分", prop: "sumPoint", width: 120 },
        ];
      }else if (that.formselect.insightCode === "2.7"){
        columnArr = [
          { name: "利用率", prop: "utilization", width: 120 },
          { name: "来源-2", prop: "from2", width: 200 },//prop待定
        ];
      }
      else if (that.formselect.insightCode === "2.9"){
        columnArr = [
          { name: "计数器", prop: "rapidCycleCounter", width: 60 },
        ];
      }
      that.columnArr = columnArr;
    },
    changeInsight() {
      let that = this;
      let typeOptions = new Array();
      if (that.formselect.insightCode === "1.1") {
        that.isShowInsightType = true;
        typeOptions = [
          { label: "Oil Filter", value: "Oil" },
          { label: "Air Filter", value: "inleTvacuum" },
          { label: "Separator Element", value: "Separator_Element" },
        ];
      } else if (that.formselect.insightCode === "1.2") {
        that.isShowInsightType = true;
        typeOptions = [
          { label: "管路", value: "Hose" },
          { label: "电机", value: "MotorTime" },
          { label: "进气阀", value: "IntakeValveMaintenanceTime" },
          { label: "温控阀", value: "TemperatureControlValveMaintenanceTime" },
          {
            label: "最小压力阀（有油）",
            value: "MinimumPressureValveMaintenanceTime",
          },
          { label: "放空阀（无油）", value: "DrainValveMaintenanceTime" },
          { label: "中冷（无油）", value: "CoolerTimeMiddle" },
          { label: "后冷", value: "CoolerTimeBehind" },
          { label: "油冷", value: "CoolerTimeOil" },
          { label: "油分离桶（有油）", value: "TankTime" },
        ];
      } else if (that.formselect.insightCode === "2.6") {
        that.isShowInsightType = true;
        typeOptions = [
          { label: "定频", value: "11" },
          { label: "变频1", value: "21" },
          { label: "变频2", value: "22" },
        ];
      } else if (that.formselect.insightCode === "2.7") {
        that.isShowInsightType = true;
        typeOptions = [
          { label: "高", value: "High" },
          { label: "低", value: "Low" },
        ];
      } else {
        that.isShowInsightType = false;
      }
      that.typeOptions = typeOptions;
      that.$set(that.formselect, "SelectCode", that.typeOptions[0]?.value);
    },
    async downLoadRunTImeFileFromS3(row){
      let that=this;
      let keyWord = 'Insight-'+that.formselect.insightCode.replace('.','-')+
      '/'+row.calculateTime.split('-')[0]+
      '/'+row.calculateTime.split('-')[1]+
      '/'+row.gsn+'-'+row.calculateTime+'.pdf';
      try {
        let res = await downLoadInsightFileFromS3(keyWord);
        // const blob = new Blob([res]);//处理文档流
        const fileName = row.keyName;
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = res.result;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } catch (error) {
        that.$message({
          showClose: true,
          message: that.$t('desc.downloadFileNotFound'),
          type: "error",
        });
      }
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getInsightList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getInsightList();
    },
    resetKeyword() {},
    initCountBar() {
      let that = this;
      // var CountBar = this.$echarts.init(document.getElementById("CountBar"));
      
      // var ColorList = ["#28739A", "#51A470"];
      let Data = this.chartDataArr;
      // var Data = [
      //   [74, 76, 176],
      //   [76, 78, 176],
      //   [78, 80, 176],
      //   [80, 82, 176],
      //   [82, 84, 176],
      //   [84, 86, 176],
      //   [86, 88, 176],
      //   [88, 90, 244],
      //   [90, 92, 187],
      //   [92, 94, 300],
      //   [94, 96, 1965],
      //   [96, 98, 2596],
      //   [98, 100, 3984],
      // ].map(function (item, index) {
      //   return {
      //     value: item,
      //   };
      // });
      var series = [];

      var optionCountBar = {
        tooltip: {
        
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 12,
            fontFamily: "Arial",
          },
          
        },
        grid: {
          top: 45,
          left: 60,
          right: 50,
          bottom: 20,
        },
        xAxis: {
          name: "",
          nameLocation: "end",
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              margin: 5,
              color: "#828393",
              fontSize: 10,
              fontFamily: "Arial",
              lineHeight: 12,
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          }, 
          scale: true,
        },
        yAxis: {
          name: "Count",
          nameLocation: "end",
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: {
          type: "custom",
          renderItem: function (params, api) {
            var yValue = api.value(2);
            var start = api.coord([api.value(0), yValue]);
            var size = api.size([api.value(1) - api.value(0), yValue]);
            var style = api.style();
            return {
              type: "rect",
              shape: {
                x: start[0]+size[0]*0.05,
                y: start[1],
                width: size[0]*0.9,
                height: size[1], 
              },
              style: style,
            };
          },
          itemStyle:{
             color: "#28739A",
          },
          label: {
            show: true,
            position: "top",
          },
          dimensions: ["From", "To", "Count"],
          encode: {
            x: [0, 1],
            y: 2,
            tooltip: [0, 1, 2],
            itemName: 3,
          },
          data: Data,
        },
      };
      that.echartID.setOption(optionCountBar);
      that.echartID.hideLoading();
      window.addEventListener("resize", () => {
        that.echartID.resize();
      });
    },
  },
};
</script>
<style scoped>
.infodiv {
  margin-top: 5px;
  border: 1px solid #d2d2d2;
  padding: 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
<style scope>
.el-table__fixed-right {
  right: 0px !important;
}
</style>
<style  scope>
.NoRaidoLabel .el-table__row .el-radio__label {
  display: none;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
</style>
 